import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import {
  Box,
  Container,
  FormControl,
  Typography,
  useTheme,
  Link,
} from "@mui/material"
import { default as image_mappcode_2 } from "../../assets/images/image_mappcode_2.png"
import { default as image_mappcode_qr_ean } from "../../assets/images/image_mappcode_qr_ean.png"
import en from "./locales/en.json"
import ResponsiveBackground from "components/ResponsiveBackground"
import { observer } from "mobx-react"
import TextField from "@mui/material/TextField"
import ContiSpecificButton from "components/ContiSpecificButton"
import useScopedTranslation from "hooks/useScopedTranslation"
import BarcodeScannerComponent from "react-qr-barcode-scanner"
import {
  ateMappCodeQrEan,
  basePath,
  contiMappCode,
  contiMappCodeQrEan,
  GTIN_CODE,
  isAte,
  isConti,
  isVDO,
} from "utils/Global"
import { scrolltToTop } from "utils/util"
import Dialog from "components/Dialog"
import { convertMAMPCode } from "components/MappCodeCard/MappCodeCard"
import { fonts_VDO } from "themes/default/tokens"

// use this namespace also for subcomponents and for smaller subpages
export const namespace = __filename

const MAPPCodeScreen = () => {
  const { t } = useScopedTranslation(
    namespace,
    (locale) => import(`./locales/${locale}.json`),
    en
  )

  const [data, setData] = React.useState(() =>
    localStorage.getItem("data") ? localStorage.getItem("data") : ""
  )
  const theme = useTheme()

  const { breakpointTablet } = theme.tokens.breakpoints
  const isMobile = window.innerWidth < breakpointTablet

  const [scan, setScan] = React.useState(false)
  const [mappCodeImg, setMapCodeImg] = React.useState(
    basePath + image_mappcode_2
  )
  const [eanCodeImg, setEanCodeImg] = React.useState(
    basePath + image_mappcode_qr_ean
  )
  const [show, setShow] = React.useState(false)
  const [showInfo, setShowInfo] = React.useState(null)
  const [showPlaceholder, setShowPlaceholder] = React.useState<boolean>(true)
  const [showTextField, setShowTextField] = React.useState<boolean>(
    !isMobile ? true : false
  )
  const [scanSuccess, setScanSuccess] = useState(false)

  const history = useHistory()

  const [productCode, setProductCode] = useState("")
  const [tempProductCode, setTempProductCode] = useState("")

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      const finalProductCode = tempProductCode ? tempProductCode : productCode
      sessionStorage.setItem("productCode", finalProductCode)
      history.push("/authenticity")
    }
  }

  const onClickHandle = () => {
    const finalProductCode = tempProductCode ? tempProductCode : productCode
    sessionStorage.setItem("productCode", finalProductCode)
    history.push("/authenticity")
  }

  // const redirectLocation = (gtin) => {
  //   history.push(generatePath("/tecdoc"))
  // }

  const handleChange = (e) => {
    const inputValue = e.currentTarget.value

    if (
      (!inputValue.includes("(21)") && !inputValue.includes("(01)")) ||
      inputValue.length < 13
    ) {
      setTempProductCode(convertMAMPCode(inputValue, false))
      setProductCode(inputValue)
    } else {
      setProductCode(inputValue)
    }
  }

  useEffect(() => {
    if (isAte) {
      setEanCodeImg(ateMappCodeQrEan)
      setMapCodeImg(contiMappCode)
    } else if (isConti) {
      setEanCodeImg(contiMappCodeQrEan)
      setMapCodeImg(contiMappCode)
    } else {
      setEanCodeImg(contiMappCodeQrEan)
      setMapCodeImg(contiMappCode)
    }
    scrolltToTop()
  }, [])

  const handleShowInfo = () => {
    setShowInfo(!showInfo)
  }

  return (
    <ResponsiveBackground theme={theme}>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "40vh",
          paddingX: isMobile ? 0 : 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
            padding: isMobile ? "0" : "0px 20px",
          }}
        >
          <Box>
            {isMobile && (
              <>
                <Box>
                  <Typography padding={"15px 0"}>
                    {t("mappCodeText")}
                  </Typography>
                </Box>
                <Box
                  width={isMobile ? "243px" : "100%"}
                  height={isMobile ? "45px" : null}
                >
                  <ContiSpecificButton
                    path="/mappcodescreen"
                    text={"QR-Code scannen"}
                    isScannIcon={true}
                    onClick={() => setScan(true)}
                  ></ContiSpecificButton>

                  <Dialog
                    open={scan || show}
                    onClose={() => {
                      setShow(false)
                      setScan(false)
                      localStorage.removeItem("data")
                    }}
                    closeStyle={{
                      color: theme.palette.text.primary,
                      label: t("close"),
                    }}
                    confirmStyle={{
                      color: theme.palette.primary.main,
                      label: t("confirm"),
                    }}
                    onAbort={() => localStorage.removeItem("data")}
                    onAccept={
                      show
                        ? () => {
                            localStorage.removeItem("data")
                            window.location.href = data
                          }
                        : null
                    }
                    title={show ? t("codeScanned") : t("scanCode")}
                    text={
                      show
                        ? data.replace(
                            /(HTTP:\/\/CONTINENTAL-AFTERMARKET\.COM\/01\/)(\d+)(\/21\/)(.*)/,
                            "(01)$2(21)$4"
                          )
                        : ""
                    }
                    content={
                      scan && (
                        <div
                          style={{
                            width: 278,
                            height: 278,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                            overflow: "hidden",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{
                              width: 278,
                              height: 278,
                              display: "block",
                              position: "absolute",
                            }}
                          >
                            <path
                              d="M336 448h56a56 56 0 0056-56v-56M448 176v-56a56 56 0 00-56-56h-56M176 448h-56a56 56 0 01-56-56v-56M64 176v-56a56 56 0 0156-56h56"
                              fill="none"
                              stroke={scanSuccess ? "#28a745" : "white"}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="10"
                            />
                          </svg>
                          <BarcodeScannerComponent
                            width={278}
                            height={278}
                            videoConstraints={{
                              facingMode: "environment",
                              aspectRatio: 1,
                            }}
                            onUpdate={(err, result) => {
                              const text = result?.getText()
                              if (!!result) {
                                if (
                                  text.match(/(01\/)(.*)(\/21\/)(.*)/) != null
                                ) {
                                  setScanSuccess(true)
                                  const _data = text.replace(
                                    /(HTTP:\/\/CONTINENTAL-AFTERMARKET.COM\/)(01\/)(.*)(\/21\/)(.*)/,
                                    `$1$2${GTIN_CODE}$4$5`
                                  )
                                  setData(_data)
                                  localStorage.setItem("data", _data)
                                  setShow(true)
                                  setScan(false)
                                } else {
                                  setScanSuccess(false)
                                }
                              }
                            }}
                          />
                        </div>
                      )
                    }
                  />
                </Box>
              </>
            )}
            <Box sx={{}}>
              <FormControl fullWidth>
                {isMobile ? (
                  <Link
                    onClick={() => setShowTextField(!showTextField)}
                    color="#000"
                  >
                    <Typography sx={{ margin: "15px 0" }}>
                      {t("manualEntry")}
                    </Typography>
                  </Link>
                ) : (
                  <Typography sx={{ marginBottom: "15px" }} variant={"body1"}>
                    {t("helpTextTablet")}
                  </Typography>
                )}
                <Box
                  sx={{
                    display: showTextField ? "flex" : "none",
                    flexDirection: "row",
                    flexFlow: isMobile ? "row wrap" : null,
                    justifyContent: isMobile ? "space-between" : null,
                    alignItems: "center",
                  }}
                >
                  <TextField
                    fullWidth={window.innerWidth > breakpointTablet}
                    id="outlined-basic"
                    variant="outlined"
                    placeholder={showPlaceholder ? "965865841253" : ""}
                    value={productCode}
                    inputProps={{ min: 0, style: { textAlign: "center" } }}
                    InputProps={{
                      style: {
                        margin: isMobile ? "0" : "15px 10px",
                        borderRadius: "30px",
                        textAlign: "center",
                        fontFamily: isAte
                          ? "Etelka Light"
                          : isVDO
                          ? fonts_VDO.fontFamily
                          : "ContinentalStagSans-Light",
                        fontSize: "18px",
                        lineHeight: "26px",
                        letterSpacing: "3px",
                        width: "100%",
                        height: isMobile ? "32px" : undefined,
                        backgroundColor: "#ffff",
                        minWidth: isMobile ? null : "250px",
                      },
                    }}
                    style={isMobile ? { flex: "0 0 70%" } : {}}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    onFocus={() => setShowPlaceholder(false)}
                    onBlur={() => setShowPlaceholder(true)}
                  />
                  <Box sx={{ margin: isMobile ? "0" : "15px 20px" }}>
                    <ContiSpecificButton
                      onClick={onClickHandle}
                      isForwardIcon={true}
                      width={isMobile ? "auto" : "30px"}
                      isFlexFlow={true}
                    ></ContiSpecificButton>
                  </Box>
                </Box>
              </FormControl>
            </Box>

            <Box />
          </Box>

          <Box sx={{ padding: "30px 0px" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <InfoOutlinedIcon onClick={handleShowInfo} />
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  marginLeft: "5px",
                }}
              >
                {t("infoMappCode")}
              </Typography>
            </Box>
            <Box sx={{ padding: "10px 10px" }}>
              {showInfo && (
                <>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "300",
                      lineHeight: "24px",
                    }}
                  >
                    {t("exampleLabelText")}
                  </Typography>
                  <img
                    src={eanCodeImg}
                    width="70%"
                    height={"70%"}
                    alt=""
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "0 auto",
                      padding: "10px 0px",
                      maxWidth: "400px",
                    }}
                  ></img>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "300",
                      lineHeight: "24px",
                    }}
                  >
                    {t("newLabelText")}
                  </Typography>
                  <img
                    src={mappCodeImg}
                    width="70%"
                    height={"70%"}
                    alt=""
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "0 auto",
                      padding: "10px 0px",
                      maxWidth: "400px",
                    }}
                  ></img>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "300",
                      lineHeight: "24px",
                    }}
                  >
                    {t("olderLabelText")}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </ResponsiveBackground>
  )
}

export default observer(MAPPCodeScreen)
